import DigitizationHeader from 'components/cattles/digitizationPage/ui/DigitizationHeader'
import { useAppDispatch, useAppSelector } from 'store/hooks'

import { useCallbackPrompt } from 'hook/useCallbackPrompt'

import PageContainer from 'layouts/PageContainer'
import { ShiftOptions } from 'models/ICattlesData'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { fetchDailyStatistics } from 'store/cattlesSlice'
import ExitWarningModal from 'ui/modal/ExitWarningModal'
import { IdentificationTableHead } from './ui'
import { TableBody } from './ui/table/TableBody'
export interface IdentificationState {
	gate: number[]
	date: number
	shift: ShiftOptions | undefined
	isDirty: boolean
}
const DigitizationPage = () => {
	const location = useLocation()

	const dispatch = useAppDispatch()
	const params = useParams()
	const { dailyStatistics } = useAppSelector(state => state.cattlesSlice)
	const cameraId = parseInt(params.cameraId)
		? parseInt(params.cameraId)
		: undefined
	const [identificationState, setIdentificationState] =
		useState<IdentificationState>({
			gate: [cameraId],
			date: moment().valueOf(),
			shift: undefined,
			isDirty: false,
		})

	useEffect(() => {
		!dailyStatistics && dispatch(fetchDailyStatistics('all'))
	}, [])
	const isOpenModal = identificationState.isDirty

	const { showPrompt, confirmNavigation, cancelNavigation } =
		useCallbackPrompt(isOpenModal)

	const currentUrl = location.pathname + location.search
	const isDefferedIdent = currentUrl.includes('deffered-digitization')
	const isRealIdent = !isDefferedIdent && currentUrl.includes('digitization')

	return (
		<PageContainer>
			<DigitizationHeader
				isAvailableIdentified={
					dailyStatistics?.identified_count.value <
					dailyStatistics?.identified_count.out_of
				}
				identifiedObj={dailyStatistics?.identified_count}
			/>
			<IdentificationTableHead
				isRealIdent={isRealIdent}
				state={identificationState}
				setState={setIdentificationState}
			/>
			<TableBody
				state={identificationState}
				setState={setIdentificationState}
				cameraId={cameraId}
				isRealIdent={isRealIdent}
			/>

			<ExitWarningModal
				open={showPrompt}
				onClose={cancelNavigation}
				onSave={() => cancelNavigation()}
				onDismiss={confirmNavigation}
				title={'Выйти без сохранения'}
				description={'Внесенные изменения будут утеряны.'}
				onSaveText={'Вернуться к редактированию'}
				onDismissText={'Выйти без сохранения'}
			/>
		</PageContainer>
	)
}

export default DigitizationPage
